import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

function ClientSection({ client, onChange }) {
  function update(field, value) {
    onChange({ client: { ...client, [field]: value } });
  }

  return (
    <section className="form-section">
      <h2 className="form-section-title">Cliente</h2>
      <div className="grid grid-cols-2 gap-4">
        <div className="col-span-2">
          <Label className="text-slate-600 text-sm">Nombre</Label>
          <Input value={client.name} onChange={function(e) { update("name", e.target.value); }} placeholder="Cliente S.L." className="input-elite mt-1" data-testid="client-name" />
        </div>
        <div className="col-span-2">
          <Label className="text-slate-600 text-sm">Dirección</Label>
          <Input value={client.address} onChange={function(e) { update("address", e.target.value); }} placeholder="Avenida 456" className="input-elite mt-1" data-testid="client-address" />
        </div>
        <div>
          <Label className="text-slate-600 text-sm">Ciudad</Label>
          <Input value={client.city} onChange={function(e) { update("city", e.target.value); }} placeholder="Barcelona" className="input-elite mt-1" data-testid="client-city" />
        </div>
        <div>
          <Label className="text-slate-600 text-sm">C.P.</Label>
          <Input value={client.postalCode} onChange={function(e) { update("postalCode", e.target.value); }} placeholder="08001" className="input-elite mt-1" data-testid="client-postal" />
        </div>
        <div>
          <Label className="text-slate-600 text-sm">CIF</Label>
          <Input value={client.cif} onChange={function(e) { update("cif", e.target.value); }} placeholder="B87654321" className="input-elite mt-1" data-testid="client-cif" />
        </div>
        <div>
          <Label className="text-slate-600 text-sm">Teléfono</Label>
          <Input value={client.phone} onChange={function(e) { update("phone", e.target.value); }} placeholder="+34 93 765 43 21" className="input-elite mt-1" data-testid="client-phone" />
        </div>
        <div className="col-span-2">
          <Label className="text-slate-600 text-sm">Email</Label>
          <Input type="email" value={client.email} onChange={function(e) { update("email", e.target.value); }} placeholder="cliente@email.com" className="input-elite mt-1" data-testid="client-email" />
        </div>
      </div>
    </section>
  );
}

export default ClientSection;
